module.exports = __webpack_public_path__ + "assets/img/xnlb_01.6d0de84d.jpg";